import React from 'react';
import * as PropTypes from 'prop-types';

function ViaContent({ children }) {
  return <main className="via-main">{children}</main>;
}

// Validate prop type parameters.
ViaContent.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ViaContent;
